import PropTypes from "prop-types";
import React from "react";

const ProductImageFixed = ({ product }) => {
  return (
    <div className="product-large-image-wrapper">
      {/*product.discount || product.new ? (
        <div className="product-img-badges">
          {product.discount ? (
            <span className="pink">-{product.discount}%</span>
          ) : (
            ""
          )}
          {product.new ? <span className="purple">New</span> : ""}
        </div>
      ) : (
        ""
      )*/}

      <div className="product-fixed-image">
        {product.image ? (
          <img
            id={"image-prod-" + product.id}
            src={global.baseUrlImage + product.image[0]}
            onError={() => {
              document.getElementById("image-prod-" + product.id).src = global.placeholderImage
              document.getElementById("image-prod-" + product.id).style.objectFit = "contain"
            }
            }
            alt=""
            className="img-fluid"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

ProductImageFixed.propTypes = {
  product: PropTypes.object
};

export default ProductImageFixed;
